"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = exports.SubHeader = exports.PageHeader = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _dedupe = _interopRequireDefault(require("classnames/dedupe"));

var _RequiredInstructions = require("./RequiredInstructions");

var _utils = require("../utils");

var _Alert = require("../../lib/alert/Alert");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var PageHeader =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PageHeader, _React$Component);

  function PageHeader(props) {
    var _this;

    _classCallCheck(this, PageHeader);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PageHeader).call(this, props));
    _this.setWrapperRef = _this.setWrapperRef.bind(_assertThisInitialized(_this));
    _this.toggleFocusedRingClass = _this.toggleFocusedRingClass.bind(_assertThisInitialized(_this));
    _this.toggleInitiallyLoaded = _this.toggleInitiallyLoaded.bind(_assertThisInitialized(_this));
    _this.state = {
      initiallyLoaded: false
    };
    return _this;
  }

  _createClass(PageHeader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          doFocus = _this$props.doFocus,
          preventScroll = _this$props.preventScroll;
      (0, _utils.focusHandler)(this.wrapperRef, doFocus, preventScroll);
      this.toggleInitiallyLoaded();
    }
  }, {
    key: "setWrapperRef",
    value: function setWrapperRef(node) {
      this.wrapperRef = node;
    }
  }, {
    key: "toggleInitiallyLoaded",
    value: function toggleInitiallyLoaded() {
      this.setState({
        initiallyLoaded: true
      });
    }
  }, {
    key: "toggleFocusedRingClass",
    value: function toggleFocusedRingClass() {
      if (this.state.initiallyLoaded) {
        this.wrapperRef.className = "page-header-focused-ring";
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          tabIndex = _this$props2.tabIndex,
          heading = _this$props2.heading,
          doFocus = _this$props2.doFocus,
          HeadingElement = _this$props2.HeadingElement;
      return _react.default.createElement(HeadingElement, {
        className: "page-header",
        tabIndex: doFocus ? tabIndex : '-1',
        ref: this.setWrapperRef,
        onFocus: this.toggleFocusedRingClass
      }, _react.default.createElement("span", null, heading));
    }
  }]);

  return PageHeader;
}(_react.default.Component);

exports.PageHeader = PageHeader;
PageHeader.defaultProps = {
  tabIndex: -1,
  doFocus: false,
  preventScroll: true,
  HeadingElement: "h2"
};
PageHeader.propTypes = {
  heading: _propTypes.default.string.isRequired,
  HeadingElement: _propTypes.default.node,
  tabIndex: _propTypes.default.number,
  doFocus: _propTypes.default.bool,
  preventScroll: _propTypes.default.bool
};

var SubHeader = function SubHeader(_ref) {
  var heading = _ref.heading,
      HeadingElement = _ref.HeadingElement;
  return _react.default.createElement(HeadingElement, {
    className: "page-sub-header"
  }, _react.default.createElement("span", null, heading));
};

exports.SubHeader = SubHeader;
SubHeader.defaultProps = {
  HeadingElement: "h3"
};
SubHeader.propTypes = {
  heading: _propTypes.default.string.isRequired,
  HeadingElement: _propTypes.default.node
};

var Container = function Container(_ref2) {
  var children = _ref2.children,
      hasSlimPadding = _ref2.hasSlimPadding,
      hasNoPadding = _ref2.hasNoPadding,
      heading = _ref2.heading,
      HeadingElement = _ref2.HeadingElement,
      hide = _ref2.hide,
      showRequiredMsg = _ref2.showRequiredMsg,
      requiredMsg = _ref2.requiredMsg,
      customClassName = _ref2.customClassName,
      doFocusPageHeader = _ref2.doFocusPageHeader,
      showAlert = _ref2.showAlert,
      alertMessage = _ref2.alertMessage;
  var cssClass = (0, _dedupe.default)('container', {
    'container--hidden': hide,
    'container--slim-padding': hasSlimPadding,
    'container--no-padding': hasNoPadding
  }, customClassName);
  var hasDefaultHeading = !!heading;
  return _react.default.createElement("div", {
    className: cssClass
  }, showRequiredMsg && requiredMsg && _react.default.createElement(_RequiredInstructions.RequiredInstructions, {
    text: requiredMsg
  }), showAlert && _react.default.createElement("div", {
    className: "cart-alert"
  }, _react.default.createElement(_Alert.Alert, {
    alertType: "info",
    hasHeading: false,
    message: alertMessage
  })), hasDefaultHeading && _react.default.createElement(PageHeader, {
    heading: heading,
    doFocus: doFocusPageHeader,
    HeadingElement: HeadingElement
  }), children);
};

exports.Container = Container;
Container.defaultProps = {
  heading: null,
  hasSlimPadding: false,
  hasNoPadding: false,
  hide: false,
  showRequiredMsg: false,
  requiredMsg: null,
  customClassName: null,
  doFocusPageHeader: true,
  showAlert: false,
  alertMessage: null,
  HeadingElement: 'h2'
};
Container.propTypes = {
  children: _propTypes.default.node.isRequired,
  hasSlimPadding: _propTypes.default.bool,
  hasNoPadding: _propTypes.default.bool,
  heading: _propTypes.default.string,
  hide: _propTypes.default.bool,
  showRequiredMsg: _propTypes.default.bool,
  requiredMsg: _propTypes.default.string,
  customClassName: _propTypes.default.string,
  doFocusPageHeader: _propTypes.default.bool,
  showAlert: _propTypes.default.bool,
  alertMessage: _propTypes.default.object,
  HeadingElement: _propTypes.default.node
};